import logo from '../../assets/images/logo-demo.png'

function Logo() {
  return (
    <img src={logo} alt="" className="h-14" />
  )
}

export default Logo
